import { push } from 'modules/gtm/modules/common';

export const gtmPushTopNavigationLevel = (navigationItem: string) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_header',
    navigation_header: {
      navigation_bar: 'top_level_1',
      navigation_item: navigationItem,

      event_category: 'navigation',
      event_action: 'top_level_1',
      event_label: navigationItem,
    },
  });
};

export const gtmPushSecondNavigationLevel = (
  columnItem: string,
  itemParentTitle: string,
) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_header',
    navigation_header: {
      navigation_bar: 'top_level_2',
      navigation_item: `${itemParentTitle} - ${columnItem}`,
      event_category: 'navigation',
      event_action: 'top_level_2',
      event_label: `${itemParentTitle} - ${columnItem}`,
    },
  });
};

export const gtmPushThirdNavigationLevel = (
  itemParentTitle: string,
  columnItem: string,
  linkTitle: string,
) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_header',
    navigation_header: {
      navigation_bar: 'top_level_3',
      navigation_item: `${itemParentTitle} - ${columnItem} - ${linkTitle}`,
      event_category: 'navigation',
      event_action: 'top_level_3',
      event_label: `${itemParentTitle} - ${columnItem} - ${linkTitle}`,
    },
  });
};

export const gtmPushBurgerMenuMobileFirstLevel = (navigationItem: string) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_burger_menu',
    navigation_header: {
      navigation_bar: 'burger_menu_mobile_level_1',
      navigation_item: `${navigationItem}`,
      event_category: 'navigation',
      event_action: 'burger_menu_mobile_level_1',
      event_label: `${navigationItem}`,
    },
  });
};

export const gtmPushBurgerMenuMobileSecondLevel = (
  itemParentTitle: string,
  columnItem: string,
) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_burger_menu',
    navigation_header: {
      navigation_bar: 'burger_menu_mobile_level_2',
      navigation_item: `${itemParentTitle} - ${columnItem}`,
      event_category: 'navigation',
      event_action: 'burger_menu_mobile_level_2',
      event_label: `${itemParentTitle} - ${columnItem}`,
    },
  });
};

export const gtmPushBurgerMenuMobileThirdLevel = (
  itemParentTitle: string,
  columnItem: string,
  linkTitle: string,
) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_burger_menu',
    navigation_header: {
      navigation_bar: 'burger_menu_mobile_level_3',
      navigation_item: `${itemParentTitle} - ${columnItem} - ${linkTitle}`,
      event_category: 'navigation',
      event_action: 'burger_menu_mobile_level_3',
      event_label: `${itemParentTitle} - ${columnItem} - ${linkTitle}`,
    },
  });
};

export const gtmPushShopNavigation = (navigationItem: string) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_shop',
    navigation_header: {
      navigation_bar: 'shop',
      navigation_item: navigationItem,
      event_category: 'navigation',
      event_action: 'shop',
      event_label: navigationItem,
    },
  });
};

export const gtmPushBurgerMenuMobile = () => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_burger_menu',
    navigation_header: {
      navigation_bar: 'burger_menu_mobile',
      navigation_item: 'undefined',
      event_category: 'navigation',
      event_action: 'burger_menu_mobile',
      event_label: 'undefined',
    },
  });
};

export const gtmPushFooterNavigation = (
  columnTitle?: string,
  itemTitle?: string,
) => {
  push({
    event: 'Generic Event',
    event_name: 'navigation_footer',
    navigation_footer: {
      navigation_bar: 'footer',
      navigation_item: columnTitle + ' - ' + itemTitle,
      event_category: 'navigation',
      event_action: 'footer',
      event_label: columnTitle + ' - ' + itemTitle,
    },
  });
};
